import Icon from "@/components/Icon";

interface Props {
  value: number;   // éléments terminés
  total: number;   // total
  /** Unité affichée dans la fraction (ex. "exercices", "séries"). */
  unit?: string;
  /** Masquer la fraction textuelle (barre seule). */
  hideLabel?: boolean;
}

/** Barre de progression fine + fraction. Vide (gris) → en cours (bleu) →
 *  complet (vert + coche). Réutilise les tokens du design system. */
export default function ProgressBar({ value, total, unit = "exercices", hideLabel = false }: Props) {
  const done = total > 0 && value >= total;
  const pct  = total > 0 ? Math.min(100, Math.round((value / total) * 100)) : 0;
  const color = done ? "var(--green)" : value > 0 ? "var(--blue)" : "var(--border)";

  return (
    <div style={styles.wrap}>
      <div style={styles.track}>
        <div style={{ ...styles.fill, width: `${pct}%`, background: color }} />
      </div>
      {!hideLabel && (
        <span style={{ ...styles.label, color: done ? "var(--green)" : "var(--text-muted)" }}>
          {done && <Icon name="done" size={12} />}
          {value}/{total} {unit}
        </span>
      )}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  wrap: { display: "flex", alignItems: "center", gap: 8, minWidth: 0 },
  track: {
    flex: 1,
    height: 6,
    borderRadius: 3,
    background: "var(--border)",
    overflow: "hidden",
    minWidth: 40,
  },
  fill: { height: "100%", borderRadius: 3, transition: "width 0.25s ease" },
  label: {
    display: "inline-flex",
    alignItems: "center",
    gap: 3,
    fontSize: 12,
    fontWeight: 600,
    whiteSpace: "nowrap",
    fontVariantNumeric: "tabular-nums",
  },
};
